<script>

import axios from 'axios';
const urlSolicistacao = process.env.VUE_APP_API_URL+"solicitacao";

export default class SolicitacoesRepository{
    

    async createSolicitacao(token,data) {
        
        const baseURL = urlSolicistacao;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.post(baseURL,data,{ headers });
        return response;
       
    }

    async  deleteSolicitacao(token,data) {
        console.log(token)
        const baseURL = urlSolicistacao+`/${data.id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL, {
            headers,
            data
        });
        return response;
       
    }

}
</script>
